import headers from './headers'

export default function(fetch) {
  return function(projectName) {
    return fetch(`${process.env.REACT_APP_API_URL}/projects`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({
        order: `/orders/${localStorage.getItem('order_id')}`,
        name: projectName,
      }),
    }).then(res => res.json())
  }
}



// WEBPACK FOOTER //
// ./src/repositories/createProject.js